import { gql } from 'graphql-tag';

// myProfile members
export const CREATE_PARTNER_ACCOUNT_EMPLOYEE = gql`
  mutation createPartnerAccountEmployee($email: String!, $partnerAccountId: Float!) {
    createPartnerAccountEmployee(
      input: { email: $email, partnerAccountId: $partnerAccountId, role: ADMIN }
    ) {
      createdAt
      email
      id
    }
  }
`;

// accounts
export const CREATE_PARTNER_CLIENT_ACCOUNT = gql`
  mutation createPartnerClientAccount($name: String!, $partnerAccountId: Float!) {
    createPartnerClientAccount(input: { name: $name, partnerAccountId: $partnerAccountId }) {
      id
      createdAt
      name
    }
  }
`;

export const CREATE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE = gql`
  mutation createPartnerClientAccountEmployee(
    $role: ActorRoleEnum!
    $partnerClientAccountId: Float!
    $email: String!
  ) {
    createPartnerClientAccountEmployee(
      input: { role: $role, partnerClientAccountId: $partnerClientAccountId, email: $email }
    ) {
      id
      createdAt
    }
  }
`;

export const INVITE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE = gql`
  mutation INVITE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE($email: String!, $id: Float!) {
    createPartnerClientAccountEmployee(input: { email: $email, partnerClientAccountId: $id }) {
      email
    }
  }
`;

export const CREATE_ACCESS_GROUP = gql`
  mutation createAccessGroup($input: CreateAccessGroupInput!) {
    createAccessGroup(input: $input) {
      id
      name
      description
      role
      partnerClientAccountId
    }
  }
`;

export const SET_TO_DEFAULT_GROUP = gql`
  mutation setToDefaultGroup(
    $partnerClientAccountEmployeeIds: [Float!]!
    $partnerClientAccountId: Float!
  ) {
    setToDefaultGroup(
      input: {
        partnerClientAccountEmployeeIds: $partnerClientAccountEmployeeIds
        partnerClientAccountId: $partnerClientAccountId
      }
    ) {
      id
      partnerClientAccountEmployeeId
    }
  }
`;

export const ADD_EMPLOYEE_TO_GROUP = gql`
  mutation addEmployeeToGroup($accessGroupIds: [Float!]!, $isAdd: Boolean!, $userIds: [Float!]!) {
    addEmployeeToGroup(input: { accessGroupIds: $accessGroupIds, isAdd: $isAdd, userIds: $userIds })
  }
`;

export const ADD_ACCESS_TO_GROUP = gql`
  mutation addAccessToGroup($input: AddAccessToGroupInput!) {
    addAccessToGroup(input: $input)
  }
`;
